"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LumpSumRateCalculator = void 0;
const models_1 = require("../models");
const lump_sum_face_amount_calculator_1 = require("./lump-sum-face-amount-calculator");
const lump_sum_premium_calculator_1 = require("./lump-sum-premium-calculator");
function calculate(options, rate, faceFactor, premiumFactor) {
    if (!premiumFactor || !faceFactor) {
        return models_1.emptyFaceAndPremium();
    }
    const premium = lump_sum_premium_calculator_1.calculateLumpSumPremium(options, rate, faceFactor, premiumFactor);
    const faceAmount = lump_sum_face_amount_calculator_1.calculateLumpSumFaceAmount(options, rate, faceFactor, premiumFactor);
    return { faceAmount, premium };
}
exports.LumpSumRateCalculator = {
    calculate,
};
//# sourceMappingURL=lump-sum-rate-calculator.js.map